import { ResponseStatus } from '@revenuemarket/http';
import { Steps, useSteps } from '@revenuemarket/react';
import { Toast } from '@revenuemarket/ui';
import { AnimatePresence } from 'framer-motion';
import { useRouter } from 'next/router';

import { useResetPassword, useSignIn } from '~hooks/queries/auth/query';

import ResetPasswordEmailStep, { ResetPasswordEmailStepModel } from './ResetPasswordEmailStep';
import ResetPasswordEmailVerificationStep, {
  ResetPasswordEmailVerificationStepModel,
} from './ResetPasswordEmailVertificationStep';
import ResetPasswordInfoStep, { ResetPasswordInfoStepModel } from './ResetPasswordInfoStep';

type StepModel = [
  ResetPasswordEmailStepModel,
  ResetPasswordEmailVerificationStepModel,
  ResetPasswordInfoStepModel,
];

interface Props {
  title: string;
  prefilledEmail?: string;
}

const ResetPasswordSteps = ({ title, prefilledEmail }: Props) => {
  const [stepModel, moveStep, resetStep] = useSteps<StepModel>({ name: 'resetPasswordSteps' });
  const router = useRouter();
  const { mutateAsync: resetPassword } = useResetPassword();
  const { mutateAsync: signIn } = useSignIn();

  return (
    <AnimatePresence>
      <Steps stepModel={stepModel}>
        <Steps.Item<StepModel, 0> step={0}>
          {(model) => (
            <ResetPasswordEmailStep
              title={title}
              prefilledEmail={prefilledEmail}
              model={model}
              onFinish={(model) => moveStep({ step: 1, model })}
            />
          )}
        </Steps.Item>
        <Steps.Item<StepModel, 1> step={1}>
          {(model) => (
            <ResetPasswordEmailVerificationStep
              model={model}
              onBack={() => moveStep({ step: 0, model })}
              onFinish={(model) => moveStep({ step: 2, model })}
            />
          )}
        </Steps.Item>
        <Steps.Item<StepModel, 2> step={2}>
          {(model) => (
            <ResetPasswordInfoStep
              model={model}
              onFinish={async (values) => {
                const response = await resetPassword(values);

                if (response.Status === ResponseStatus.SUCCESS) {
                  if (prefilledEmail !== undefined) {
                    await router.replace('/settings/me');
                  } else {
                    await signIn({
                      email: values.email,
                      password: values.password,
                    });

                    await router.replace('/');
                  }
                  await resetStep();
                } else {
                  Toast.error('비밀번호 재설정에 실패했습니다');
                }
              }}
            />
          )}
        </Steps.Item>
      </Steps>
    </AnimatePresence>
  );
};

export default ResetPasswordSteps;
